module.exports = __webpack_public_path__ + "static/media/youtube.06c249b2.svg";